<template>
    <div class="national-social-studies">
        <Navbar :state="state" :subject="subject" >
<!--            <template v-slot:navMsg>-->
<!--                <TempAvailabilityMessage />-->
<!--            </template>-->
        </Navbar>

        <section class="bg-light product-section" :style="{backgroundImage: 'url(' + backgroundImage + ')'}">
            <div class="py-4" :class="{'overlay': backgroundImage}">
                <div class="container">
                    <Product
                        :product="product"
                        :publications="nationalSocialStudiesPublications"
                        :state="state"
                        :grade="grade"
                        :subject="subject"
                        :language="language"
                    />
                </div>
            </div>
        </section>
        <BlockListViewer v-if="blocks" :blocks="blocks" :publications="pagePublications" />
        <!-- <svg class="curve-down" xmlns="http://www.w3.org/2000/svg" version="1.1" width="100%" height="100" viewBox="0 0 100 100" preserveAspectRatio="none">
            <path d="M0 0 C 50 100 80 100 100 0 Z"></path>
        </svg> -->

        <Footer />
    </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/_colors.scss";

.product-section {
    background-size: cover;
    background-repeat: no-repeat;
}

.product-section .overlay {
    height: 100%;
    background-color: rgba(0, 0, 0, .33);
}

.curve-down path {
    fill: $light;
    stroke: $light;
}

.thb-divider-container {
    position: absolute;
    top: auto;
    bottom: -1px;
    left: -1px;
    width: calc(100% + 2px);
    transform: translateZ(0);
    pointer-events: none;
}

.thb-svg-divider {
    fill: #f8f9fa;
}

.thb-divider-container .thb-svg-divider {
    width: 100%;
    left: 0;
    bottom: -1px;
    height: 100%;
    position: absolute;
}

.thb-divider-container.waves_opacity .thb-svg-divider path:nth-child(2) {
    fill-opacity: 0.15;
}

.thb-divider-container.waves_opacity .thb-svg-divider path:nth-child(3) {
    fill-opacity: 0.3;
}
</style>

<script>
import { mapState } from 'vuex'

import states from '@/common/states'

import Navbar from '@/components/Navbar'
import Product from '@/components/Product'
import Footer from '@/components/Footer'

import RawView from '@/components/blocks/RawView'
import OnlineView from '@/components/blocks/OnlineView'
import StudentMaterialsView from '@/components/blocks/StudentMaterialsView'
import NationalMaterialsView from '@/components/blocks/NationalMaterialsView'
import TeacherMaterialsView from '@/components/blocks/TeacherMaterialsView'
import WhatYouGetView from '@/components/blocks/WhatYouGetView'
import TempAvailabilityMessage from "@/components/TempAvailabilityMessage";
import BlockListViewer from "@/components/blocks/BlockListViewer.vue";

export default {
    name: 'national-social-studies',
    data: () => ({
        states: states,
        blocks: [],
    }),
    props: ['state', 'grade', 'subject', 'language'],
    computed:mapState({
        stateData: state => state.stateData.stateData,
        selectedState: state => state.stateData.selectedState,
        selectedLanguage: state => state.stateData.selectedLanguage,
        publicationResources: state => state.stateData.publicationResources,
        nationalSocialStudiesPublications () {
            var nationalSocialStudiesPublications = []

            _.forEach(this.stateData.publications, publication => {
                if(
                    publication.topic == 'National Social Studies' &&
                    publication.language == this.language
                ) {
                    nationalSocialStudiesPublications.push(publication)
                }
            })

            nationalSocialStudiesPublications = _.orderBy(nationalSocialStudiesPublications, 'grade')
            nationalSocialStudiesPublications = _.uniqBy(nationalSocialStudiesPublications, 'grade')

            return nationalSocialStudiesPublications
        },
        product () {
            let product = {}

            _.filter(this.nationalSocialStudiesPublications, publication => {
                if (
                    publication.grade    == this.$route.params.grade &&
                    publication.language == this.$route.params.language
                ) {
                    product = publication
                }
            })

            return product
        },
        backgroundImage () {
            var backgroundImage = null
            if (this.stateData.product_bg) {
                if (
                    this.stateData.product_bg.startsWith('http://') ||
                    this.stateData.product_bg.startsWith('https://') ||
                    this.stateData.product_bg.startsWith('//')
                ) {
                    backgroundImage = this.stateData.product_bg
                } else {
                    backgroundImage = '//' + this.stateData.product_bg
                }
            }
            return backgroundImage
        }
    }),
    watch: {
        selectedState: {
            handler(state) {
                if (!this.$route.params.state || this.$route.params.state !== state) {
                    this.pushRoute(this.subjectName, state, 0, 'en')
                    return;
                }
                this.getPageBlocks();
            }
        },
        '$route': {
            handler (route) {
                if (!route.params.state) {
                    this.$router.push({
                        name: 'national-social-studies',
                        params: {
                            state: this.selectedState,
                            grade: 0,
                            subject: 'national-social-studies',
                            language: 'en'
                        }
                    })
                }
            },
            deep: true,
            immediate: true
        }
    },
    components: {
        BlockListViewer,
        TempAvailabilityMessage,
        Navbar,
        Product,
        Footer,
        OnlineView,
        RawView,
        StudentMaterialsView,
        TeacherMaterialsView,
        NationalMaterialsView,
        WhatYouGetView
    },
    methods: {
        getPublicationResources () {
            this.$store.dispatch('getPublicationResources', this.pageId)
        },
        getPageBlocks() {
            this.$store.dispatch('getPageBlocks', {pageId: this.pageId, state: this.selectedState})
                .then((data) => {
                    this.blocks = data;
                })
        },
        formattedState (value) {
            var formattedState = null
            _.forEach(this.states, state => {
                if (value == state.state) {
                    formattedState = state.fullState
                }
            })
            return formattedState
        },
        formattedSubject (subject) {
            var subject = subject.replace(/-/g, " ")
            return subject
        }
    },
    created() {
        this.getPublicationResources()
        this.getPageBlocks();
    }
}
</script>
